import { doesExistValueForKey } from '../utils/doesExistValueForKey'
import { Person } from './Person'
import type { ISelectItem } from '~/types/models'
import type { ITeamMember } from '~/types/teamMember/models'
import { TeamMemberRoleIds } from '~/services/selectLists/teamMemberRoles'

export function TeamMember(o: ITeamMember): ITeamMember {
  const fn = '[cynqueModules/dataObjects/TeamMember.ts] TeamMember |'
  if (!o) {
    throw new Error(`${fn} TeamMember called with falsey teamMember`)
  }
  if (!o.person) {
    throw new Error(`${fn} TeamMember called with falsey teamMember.person`)
  }

  const obj = { ...o }

  obj.person = Person(obj.person)
  obj.avatar = { descr: obj.person.name.initials ?? '', type: 'teamMember' }
  obj.descr = obj.person.name.descr + ' - ' + obj.defaultRole.label
  obj.label = obj.person.label
  obj.role = obj.defaultRole // for display purposes along with other entities with roles
  obj.roles = obj.defaultRoles // New version that supports multiple roles. Above will go away in a while. JR
  obj.numAccounts = obj.numAccounts ? obj.numAccounts : 0
  obj.numOrders = obj.numOrders ? obj.numOrders : 0
  obj.numProjects = obj.numProjects ? obj.numProjects : 0

  obj.isOrderAdministrator =
    doesExistValueForKey<ISelectItem>({
      arr: obj.roles,
      key: 'id',
      value: TeamMemberRoleIds.ORDER_ADMINISTRATOR,
    }) || obj.defaultRole.id === TeamMemberRoleIds.ORDER_ADMINISTRATOR

  obj.isSalesManager =
    doesExistValueForKey<ISelectItem>({
      arr: obj.roles,
      key: 'id',
      value: TeamMemberRoleIds.SALES_MANAGER,
    }) || obj.defaultRole.id === TeamMemberRoleIds.SALES_MANAGER

  obj.isCommissionManager =
    doesExistValueForKey<ISelectItem>({
      arr: obj.roles,
      key: 'id',
      value: TeamMemberRoleIds.COMMISSION_MANAGER,
    }) || obj.defaultRole.id === TeamMemberRoleIds.COMMISSION_MANAGER

  obj.isCasesManager =
    doesExistValueForKey<ISelectItem>({
      arr: obj.roles,
      key: 'id',
      value: TeamMemberRoleIds.CASES_MANAGER,
    }) || obj.defaultRole.id === TeamMemberRoleIds.CASES_MANAGER

  obj.isServiceRequestsManager =
    doesExistValueForKey<ISelectItem>({
      arr: obj.roles,
      key: 'id',
      value: TeamMemberRoleIds.SERVICE_REQUESTS_MANAGER,
    }) || obj.defaultRole.id === TeamMemberRoleIds.SERVICE_REQUESTS_MANAGER

  return obj
}
